export class TelemetryView {
  key: string;
  translateKey: string;
  inCabDefaultView: boolean; // default false
  inCabDefaultViewOrder: number;
  category: string; //"telemetry"
  reportViewOrder: number;
  trace: boolean; // default true
  customName: boolean; // default false
  workingWidth: boolean; // default false
  signalGraph: boolean; // default true
  tooltipMap: boolean; // default true
  fuelComponent: boolean; // false
  engineOilTempComponent: boolean; // false
  tempCoolantComponent: boolean; // false
  co2Component: boolean; // false
  equipmentType: string; //def null
  tooltipLastState?: boolean;
  booleanLabel?: string; // fals string | true string
  booleanConfigLabel?: string; // false label | true label
  configPath?: string; //path for false label | path for true label
  customNameString: string; //this value is manage by frontend for comodity

  actualSpeed: boolean; // default false
  instantaneousFuelConsumptionPerTime: boolean; // default false
  instantaneousFuelConsumptionPerArea: boolean; // default false
  actualEngineSpeed: boolean; // default false
  actualEngineTorque: boolean; // default false
  gnssQuality: boolean; // default false
  actualPtoSpeed: boolean; // default false
  actualPtoTorque: boolean; // default false
  plot: string; // default false

  constructor() {
    this.key = null;
    this.translateKey = null;
    this.inCabDefaultView = null;
    this.inCabDefaultViewOrder = null;
    this.category = null;
    this.reportViewOrder = null;
    this.trace = null;
    this.customName = null;
    this.workingWidth = null;
    this.signalGraph = null;
    this.tooltipMap = null;
    this.fuelComponent = null;
    this.engineOilTempComponent = null;
    this.tempCoolantComponent = null;
    this.co2Component = null;
    this.equipmentType = null;
    this.customNameString = null;
    this.tooltipLastState = null;
    this.booleanLabel = null;
    this.booleanConfigLabel = null;
    this.configPath = null;
    this.actualSpeed = null;
    this.instantaneousFuelConsumptionPerTime = null;
    this.instantaneousFuelConsumptionPerArea = null;
    this.actualEngineSpeed = null;
    this.actualEngineTorque = null;
    this.gnssQuality = null;
    this.actualPtoSpeed = null;
    this.actualPtoTorque = null;
    this.plot = null;
  }
}

export const PLOT_ICONS_MAPPING = {};
